import { Anchor, ArrowIcon } from "./styles";
import AppLinkComponent, { AppLinkProps } from "@/components/AppLink";

// Cast to fix React 17 + @types/react 18 compatibility issue
const AppLink = AppLinkComponent as any;

export type InternalLinkProps = AppLinkProps & {
  title: string;
};

const InternalLink: React.FC<InternalLinkProps> = (props) => {
  const { title, page, params } = props;

  return (
    <AppLink page={page} params={params}>
      <Anchor>
        <span>{title}</span>
        <ArrowIcon />
      </Anchor>
    </AppLink>
  );
};

export default InternalLink;
